export const SWITCH_THEME = 'SWITCH_THEME';

export type ThemeAction = { type: typeof SWITCH_THEME };

export const switchThemeAction = (): ThemeAction => ({ type: SWITCH_THEME });
